var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card v-center"},[_c('ListIcon'),_vm._v(" "+_vm._s(_vm.$t('wallet.operation_history'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }